/* ========================================================================
 * Add to cart logic
 *
 * includes variation filtering
 * ======================================================================== */

/* global productCardTexts dataLayer */

import $ from "jquery";
import "../vendor/slick";
import slickLightbox from "../vendor/slick-lightbox";
import ImageZoomPan from "./image-zoom-pan";
import General from "./general";
import ProductQuestions from "./product-questions";
import PriceHistoryHandler from "./price-history";
import Basket from "./basket";
import Loop54Connector from "./Loop54/loop54-connector";

export default function () {

	const loop54Connector = new Loop54Connector();

	const addToBasketButton = document.querySelector(
		".product-property #add-to-basket-btn"
	);

	const clickAndCollectButton = document.querySelector(".product-property .click-and-collect-button");
	let clickAndCollectPossible = false;
	if (clickAndCollectButton) {
		clickAndCollectPossible = true;

		switch (clickAndCollectButton.dataset.clickAndCollectStatus) {
			case "-1":
			case "-2":
				clickAndCollectPossible = false;
				break;
		}
	}

	let hasAddToBasketButton = false;
	let addToBasketDisabled = false;
	if (addToBasketButton) {
		hasAddToBasketButton = true;
		if (addToBasketButton.disabled === true) {
			addToBasketDisabled = true;
		}
	} else {
		addToBasketDisabled = true;
	}

	const infoTexts = typeof (productCardTexts) !== "undefined" ? productCardTexts : {};

	//Amount selector is for both product & package
	$(".product-property.amount .amount-controller").click(function () {
		var $amountInput = $(this).parent().find("#product-amount"),
			currentAmount = parseInt($amountInput.val()),
			buyMinAmount = parseInt($amountInput.data("buy-min-amount")),
			buyMaxAmount = parseInt($amountInput.data("buy-max-amount")),
			buyMultipleAmount = parseInt($amountInput.data("buy-multiple-amount")),
			newAmount,
			amountChange = 1;

		// If buy_multiple_amont is set in products-database
		// then we always change the product amount by it instead of the default 1
		if (buyMultipleAmount) {
			amountChange = buyMultipleAmount;
		}

		if ($(this).is(".up")) {
			newAmount = currentAmount + amountChange;
		} else {
			newAmount = Math.max(currentAmount - amountChange, 1);
		}

		//Cannot order less that product.buy_min_amount
		if (newAmount < buyMinAmount) {
			newAmount = buyMinAmount;
		}

		//Cannot order more that product.buy_max_amount
		if (buyMaxAmount && newAmount > buyMaxAmount) {
			newAmount = buyMaxAmount;
		}

		$amountInput.val(newAmount);
	});

	//Rest from here is only product specific
	const $images = $(".large-images");
	const $thumbs = $(".thumbs");
	const $productEl = $(".js-product-article");
	const $body = $("body");

	if ($images.length !== 0) {
		$("document").ready(function () {
			resetImagesAndThumbs(0);
		});
	}

	if ($productEl.length === 0) {
		return;
	}

	PriceHistoryHandler.init();
	ProductQuestions.init();

	const url = $productEl.data("sizes-url"),
		$alertArea = $("form.add-to-basket .alert-area", $productEl),
		productColor = $productEl.data("product-color-name"),
		productBrand = $productEl.data("product-brand-name");

	//Check product-size labels' biggest width
	const getBiggestLabelWidth = () => {
		let maxLabelWidth = 0;
		$("#product-size > label").each(function () {
			var labelWidth = $(this).outerWidth();
			if (labelWidth > maxLabelWidth) {
				maxLabelWidth = labelWidth;
			}
		});
		return maxLabelWidth;
	};

	//Get variations on page load
	$.ajax({
		url: url,
		type: "GET",
		dataType: "html",
		success: function (data) {
			if (data.trim() !== "") {

				const sizes = document.createElement("div");
				sizes.innerHTML = data;

				const productSizes = document.querySelector("#product-size") || document.createElement("div");

				const removeLabels = {};

				let availableFromWebAndStores = 0; // item-balance-status = 3
				let availableFromWeb = 0; // item-balance-status = 2
				let availableFromStores = 0; // item-balance-status = 1
				let notAvailable = 0; // item-balance-status = 0
				let sizesCount = 0;

				// Filter out gray sizes for products that have click and collect/availibilty disabled.
				for (const sizeElement of sizes.querySelectorAll("input, label")) {

					const tagType = sizeElement.tagName;
					let balanceStatus = 0;

					if (tagType === "INPUT") {

						balanceStatus = parseInt(sizeElement.dataset.itemBalanceStatus);
						sizesCount++;

						switch (balanceStatus) {
							case 3:
								availableFromWebAndStores++;
								break;
							case 2:
								availableFromWeb++;
								break;
							case 1:
								availableFromStores++;
								break;
							case 0:
								notAvailable++;
								break;
						}
					}

					if (tagType === "INPUT" && balanceStatus < 2 && !clickAndCollectPossible) {
						removeLabels[sizeElement.id] = true;
						continue;
					}

					if (tagType === "LABEL" && removeLabels[sizeElement.htmlFor]) {
						continue;
					}

					if ((tagType === "INPUT") || (tagType === "LABEL")) {
						productSizes.appendChild(sizeElement);
					}
				}

				var $select = $("#product-size");

				//If only one selectable option, autoselect it
				var noSizeArray = ["", "-", "NOSI", "OS", "One size"];
				if (
					$("input", $select).length === 1 &&
					noSizeArray.indexOf($("input", $select).data("name")) >= 0
				) {
					//Select the only option
					$("input", $select).prop("checked", true);
					$(".product-property.size").addClass("hidden");
					//Trigger availability request
					$("#product-size", $productEl).trigger("change");
				}

				if ($select[0]) {
					const sizes = $select[0].querySelectorAll("input");

					if (addToBasketButton && ((sizesCount === availableFromStores) || (sizesCount === notAvailable))) {
						addToBasketButton.textContent = "Loppu verkkokaupasta";
						addToBasketButton.title = "Loppu verkkokaupasta";
						toggledDisableBasketButton(true);
					}

					if (clickAndCollectButton && (sizesCount === availableFromWeb) || (sizesCount === notAvailable)) {
						clickAndCollectButton.textContent = "Loppu myymälöistä";
						clickAndCollectButton.title = "Loppu myymälöistä";
						clickAndCollectButton.disabled = true;
					}

					if (sizes.length === 0) {
						const sizeContainer = document.querySelector(".product-property.size");
						if (sizeContainer) {
							sizeContainer.classList.add("hidden");
						}

						General.showAlert("Saatavilla olevat tuotteen koot ovat varattuina ostoskoreissa tai tuote on loppunut verkkokaupasta.", $alertArea, "danger");
					}
				}

				//Set same width to every product size label
				var labelWidth = getBiggestLabelWidth();
				$("#product-size > label").css("min-width", labelWidth);

				//Relocate size-table-link ("Kokotaulukko") after last product label
				if ($(".size-table-link").length) {
					$(".size-table-link").insertAfter("#product-size > label:last");
					$("#product-size > label:last").css("margin-right", "1em"); //add margin
				}
			}
			//Empty response so product has no available sizes
			//Hide add to basket form and show notice instead
			else {
				$(".add-to-basket").hide();
				$(".product-delivery-methods").append(
					'<p class="alert alert-warning">' + infoTexts.variantNotAvailable + "</p>"
				);
			}

			// if(product.sizeChartUrl) {
			//   $('#product-size').innerHTML = '<a href="<%= product.sizeChartUrl %>" class="open-modal text" data-modal-classes="modal-size-chart">Kokotaulukko</a>'
			// }
		}
	});

	var delay = (function () {
		var timer = 0;
		return function (callback, ms) {
			clearTimeout(timer);
			timer = setTimeout(callback, ms);
		};
	})();

	//Image previews
	$(".product-images .image-actions a", $productEl).on("click", function (e) {
		e.preventDefault();
		var targetEl = $(this).data("target");

		//Remove selected class from this thumb and large image
		$(".product-images .image-actions a").removeClass("selected");
		$(".product-images .image img").removeClass("selected");

		$(this).addClass("selected");

		$(targetEl, ".product-images .image").addClass("selected");
	});

	//Slick slider settings
	$images.slick({
		arrows: false,
		asNavFor: ".thumbs",
		dots: false,
		fade: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					asNavFor: false,
					dots: true,
					fade: false
				}
			}
		],
		speed: 200
	})
		.on({
			setPosition: function () {
				setImagesSlideHeight();
			},
			beforeChange: function (event, slick, currentSlide, nextSlide) {
				setActiveThumbClass(nextSlide);
			}
		});

	$thumbs.slick({
		arrows: true,
		centerMode: false,
		dots: false,
		focusOnSelect: true,
		infinite: false,
		nextArrow: '<div class="slick-prev-button"></div>',
		prevArrow: '<div class="slick-next-button"></div>',
		slidesToScroll: 2,
		slidesToShow: 6,
		swipeToSlide: true,
		variableWidth: true
	})
		.on("click", ".product-thumbs-slide", function () {
			$images.slick("slickGoTo", $(this).index());
		});
	slickLightbox();
	$images.slickLightbox({
		background: "#fff",
		imageMaxHeight: 1,
		itemSelector: ".product-images-slide",
		useHistoryApi: true,
		layouts: {
			closeButton: '<button type="button" class="slick-lightbox-close"><span class="close-icon" aria-hidden="true"></span></button>'
		},
		slick: {
			arrows: true,
			asNavFor: ".large-images, .thumbs",
			dots: false,
			fade: true,
			infinite: false,
			nextArrow: '<div class="slick-next-button"></div>',
			prevArrow: '<div class="slick-prev-button"></div>',
			responsive: [
				{
					breakpoint: 990,
					settings: {
						arrows: false,
						dots: true,
						fade: false
					}
				}
			],
			speed: 200
		},
		src: function (element) {
			return $(element).find("img").attr("src");
		}
	})
		.on({
			setPosition: function () {
				setImagesSlideHeight();
			},
			beforeChange: function (event, slick, currentSlide, nextSlide) {
				setActiveThumbClass(nextSlide);
			},
			"show.slickLightbox": function () {
				$body.addClass("slick-lightbox-open");

				const $slickLightbox = $images[0].slickLightbox.slick;

				$slickLightbox.find(".slick-lightbox-slick-item").each(function () {
					const $img = $(this).find("img");

					new ImageZoomPan($img[0]);

					$img.on("zoomChange", function (e) {
						const currentZoom = e.originalEvent.detail.currentZoom;
						const slickEnabled = currentZoom > 1 ? false : true;

						$slickLightbox.slick("slickSetOption", {
							accessibility: slickEnabled,
							draggable: slickEnabled,
							swipe: slickEnabled,
							touchMove: slickEnabled
						}, false);

						$slickLightbox.find(".slick-prev-button, .slick-next-button, .slick-dots").css({
							opacity: !slickEnabled ? 0 : "",
							pointerEvents: !slickEnabled ? "none" : ""
						});
					});
				});
			},
			"hide.slickLightbox": function () {
				$body.removeClass("slick-lightbox-open");
			}
		});

	function setImagesSlideHeight() {
		var $slides = $images.find(".product-images-slide").css("height", "");

		// For mobile: get the height from the tallest image (but no more than the width of the image)
		// For desktop: set height the same as the image width
		if (isSingleColumn()) {
			var imageHeights = $slides
				.map(function () {
					return $(this)
						.find("img")
						.height();
				})
				.get();

			$slides.height(
				Math.min($slides.width(), Math.max.apply(null, imageHeights))
			);
		} else {
			$slides.each(function () {
				var $this = $(this);
				$this.height($this.find("img").width());
			});
		}
	}

	/**
	 * setThumbsWidth
	 */
	function setThumbsWidth() {
		if (!isSingleColumn() && $thumbs.length) {
			var thumbsTotalWidth = 0;
			var slidesToShow;

			$thumbs[0].slick.$slides.each(function () {
				thumbsTotalWidth += $(this).outerWidth(true);
			});

			$thumbs.width("");

			if (thumbsTotalWidth < $thumbs.width()) {
				slidesToShow = 10;
				$thumbs.width(thumbsTotalWidth);
			} else {
				slidesToShow = 7;
			}

			$thumbs.slick("slickSetOption", "slidesToShow", slidesToShow, true);
		}
	}

	/*
	* setActiveThumbClass
	*/
	function setActiveThumbClass(i) {
		i = typeof i !== "undefined" ? i : 0;
		if (!isSingleColumn()) {
			$thumbs
				.find(".product-thumbs-slide")
				.removeClass("slick-real-active")
				.eq(i)
				.addClass("slick-real-active");
		}
	}

	/**
	 * isSingleColumn
	 *
	 * @return {Boolean}
	 */
	function isSingleColumn() {
		return window.innerWidth < 768;
	}

	//Update availabilities per EAN
	$("#product-size", $productEl).on("change", function (e) {
		//Clear possible errors
		$(this)
			.parent()
			.removeClass("has-error");
		General.hideAlert($alertArea);

		//Get store availabilities - Click and Collect handles these now.
		//getStoreAvailabilities($(this).val(), $('option:selected', this).text(), productColor, productBrand);
		// getStoreAvailabilities($('.product-article form').find('[name="ean"]:checked').val(), $('option:selected', this).text(), productColor, productBrand);
	});

	/*
	* Test if browser supports a CSS property
	*
	* @param {String} property
	* @param {Array} [prefixes]
	* @param {Function} [callback]
	*
	* @return {Boolean|Function}
	*/
	function supportsCSSProperty(property, prefixes, callback) {
		if (typeof property === "undefined") return;

		var div = document.createElement("div");
		var hasSupport = false;

		if (typeof div.style[property] !== "undefined") {
			hasSupport = true;
		} else if (typeof prefixes !== "undefined" && prefixes && prefixes.length) {
			property = property.charAt(0).toUpperCase() + property.substr(1);

			for (var i = 0; i < prefixes.length; ++i) {
				if (prefixes[i] + property in div.style) {
					hasSupport = true;
					break;
				}
			}
		}

		return typeof callback === "function" ? callback(hasSupport) : hasSupport;
	}

	/*
	* Simple polyfill for images which use object-fit
	*
	* @param {Element} container
	*/
	function addObjectFitPolyfill(container) {
		container = typeof container !== "undefined" ? container : document;
		var hasObjectFitSupport = supportsCSSProperty("objectFit");

		if (!hasObjectFitSupport) {
			var images = container.querySelectorAll(".object-fit-polyfill");
			var styles = {
				backgroundSize: "contain",
				backgroundPosition: " center center",
				backgroundRepeat: "no-repeat"
			};

			for (var i = 0; i < images.length; i++) {
				var image = images[i];
				var parent = image.parentNode;

				if (!image.classList.contains("object-fit-polyfilled")) {
					image.style.opacity = 0;
					image.classList.add("object-fit-polyfilled");
				}

				if (!parent.classList.contains("object-fit-polyfilled")) {
					styles.backgroundImage = "url(" + image.src + ");";

					for (var style in styles) {
						parent.style[style] = styles[style];
					}

					parent.classList.add("object-fit-polyfilled");
				}
			}
		}
	}

	function resetImagesAndThumbs(pos) {
		pos = typeof pos !== "undefined" ? pos : 0;
		$images.slick("slickGoTo", pos, true);
		setThumbsWidth();
		setImagesSlideHeight();
		setActiveThumbClass(pos);

		addObjectFitPolyfill();
	}

	//Disable add to basket button if there's no online availability.
	function productSizeClickHandler(e) {
		var clickedElement = e.target;

		if (clickedElement.tagName === "LABEL" && clickedElement.htmlFor) {
			var itemBalanceStatus = document
				.querySelector("#" + clickedElement.htmlFor)
				.getAttribute("data-item-balance-status");
			if (itemBalanceStatus) {
				itemBalanceStatus = parseInt(itemBalanceStatus);
			} else {
				itemBalanceStatus = 3;
			}


			if (itemBalanceStatus < 2) {
				toggledDisableBasketButton(true);
				setTimeout(function () {
					General.showAlert(
						itemBalanceStatus === 0 ? "Koko on loppunut." : infoTexts.sizeNotAvailable,
						$alertArea,
						"danger",
						4000
					);
				}, 250);
			} else {
				toggledDisableBasketButton(false);
			}

		}
	}

	function toggledDisableBasketButton(state = true) {
		if (addToBasketDisabled) {
			return;
		}
		if (addToBasketButton) {
			addToBasketButton.disabled = state;
		}
	}

	const productSizeArea = document.querySelector("#product-size");
	if (productSizeArea) {
		productSizeArea.addEventListener("click", productSizeClickHandler);
	}


	// Add product to basket
	$("form.add-to-basket", $productEl).on("submit", function (e) {
		e.preventDefault();

		if (addToBasketDisabled) {
			return false;
		}

		General.hideAlert($alertArea);

		let $form = $(this);
		let ean = $form.find('[name="ean"]:checked').val();

		if (!ean) {
			//Size not selected
			$("#product-size")
				.parent()
				.addClass("has-error");
			General.showAlert("Valitse koko ensin.", $alertArea, "danger", 5000);
		} else {

			if (!ProductQuestions.checkAnswers()) {
				General.showAlert("Vastaathan ensiksi lisäkysymyksiin.", $alertArea, "danger", 5000);
				return false;
			}

			let additionalQuestionsObject = ProductQuestions.getAnswers();

			//Ean and amount are needed to add product to basket,
			//other properties are for analytics
			let productParams = {
				ean: ean,
				amount: 1, //$form.find('[name="amount"]').val(),
				id: $form.data("product-id"),
				name: $form.data("product-name"),
				price: $form.data("product-price"),
				brand: $form.data("product-brand"),
				category: $form.data("product-category"),
				color: $form.data("product-variant"),
				colorId: $form.data("product-color"),
				size: $form.find('[name="ean"]:checked').data("name")
			};

			//OK to add to basket
			Basket.addProduct(
				productParams,
				true,
				function (data) {
					//Show success message
					//General.showAlert(data.txt, $alertArea, "success", 3000);
				},
				function (data) {
					General.showAlert(data.txt, $alertArea, "danger");
				},
				additionalQuestionsObject
			);
		}
	});

	//Return device size (xs, sm, md lg)
	function getBootstrapDeviceSize() {
		return $("#users-device-size")
			.find("div:visible")
			.first()
			.attr("id");
	}

	var screenSize = getBootstrapDeviceSize();

	//Calculate description full height
	var calculateFullHeight = function () {
		var elem = $(".toggle-text").clone();
		var deviceSize = getBootstrapDeviceSize();

		if (deviceSize === "xs") {
			elem.insertAfter(".visible-xs .toggle-text");
		} else {
			elem.insertAfter(".hidden-xs .toggle-text");
		}

		elem.css("height", "auto");
		var fullHeight = elem.outerHeight();
		elem.remove();

		return fullHeight;
	};

	//Show more or less description
	$(".toggle-description").click(function (e) {
		e.preventDefault();

		if ($(".toggle-text").hasClass("show-less-height")) {
			$(this).text("Näytä vähemmän");
			$(".toggle-text").css("height", calculateFullHeight());
		} else {
			$(this).text("Näytä lisää...");
			$(".toggle-text").css("height", "");
		}
		$(".toggle-text").toggleClass("show-less-height");
	});

	if ($images.length !== 0) {
		$(window).resize(function () {
			delay(function () {
				var newSize = getBootstrapDeviceSize();
				var oldSize = screenSize;
				if (oldSize !== newSize) {
					resetImagesAndThumbs();
					screenSize = newSize;
				}
			}, 500);
		});
	}


	// Fetch loop54 products via AJAX and place them to the carousel's products container.
	function updateLoop54CarouselProducts(type = "") {
		let $contentFlagId;

		switch (type) {
			case "relatedEntities":
				$contentFlagId = "related-entities-product-carousel";
				break;
			case "complementaryEntities":
				$contentFlagId = "complementary-entities-product-carousel";
				break;
			default:
				return Promise.reject();
		}

		const $contentFlag = $(`#${$contentFlagId}`);
		const $parentContainer = $contentFlag.closest(".product-list-slider-container");

		if (!$contentFlag) return Promise.reject();

		try {
			const sapId = $productEl.data("product-id");
			const colorId = $productEl.data("product-color");
			const userId = loop54Connector.getId();

			const params = {
				userId,
				product: { sapId, color: colorId },
				type
			};

			if (!userId || !sapId || !colorId) return;

			return $.ajax({
				data: params,
				dataType: "text",
				url: "/stage-ajax/getCarouselProducts/"
			}).then(res => {
				const emptyResponse = res.trim() === "";

				if (emptyResponse) {
					$parentContainer.remove();
				} else {
					$contentFlag.replaceWith(res);
				}
			}).then(() => {
				$parentContainer.find(".product-link").on("click", function(e) {
					e.preventDefault();
					const productHref = $(this).attr("href");
					const entity = { type: "Product", id: `${sapId}_${colorId}` };
					loop54Connector.createEvent("click", entity, () => window.location.href = productHref);
				});

				// add loop54Side to dataLayer for analytics

				// find first .slider-product element from parent container and get data-loop54side attribute and push it to dataLayer.
				const loop54Side = $parentContainer.find(".slider-product").first().data("loop54side");

				if (loop54Side) {
					dataLayer?.push({ loop54Side });
				}
			});

		} catch(e) {
			console.log(e);

			return Promise.reject();
		}
	}

	(async function fetchLoop54CarouselProducts() {
		await updateLoop54CarouselProducts("relatedEntities");
		await updateLoop54CarouselProducts("complementaryEntities");

		import("./slick").then(({ default: Slick }) => {
			Slick();
		});
	})();

}
